import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTableReport = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M21.9219 10V14.2488C21.9207 14.7348 21.7271 15.2006 21.3835 15.5444C21.0399 15.8882 20.5742 16.0819 20.0881 16.0834H17",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 21.0053V12.7816C13.0007 12.5387 13.0976 12.3059 13.2694 12.134C13.4412 11.9623 13.6739 11.8654 13.9169 11.8647H18",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.1094 16.0834V21.0053",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7031 21.0053H20.5156",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7344 21.2812H4.40625C4.03329 21.2812 3.6756 21.1331 3.41188 20.8694C3.14816 20.6057 3 20.2479 3 19.875V4.40625C3 4.03329 3.14816 3.67561 3.41188 3.41188C3.6756 3.14816 4.03329 3 4.40625 3H14.3709C14.7436 3.00008 15.1011 3.14811 15.3647 3.41156L18.0572 6.10406C18.3206 6.36769 18.4687 6.72511 18.4688 7.09781V9.32812",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 8.5C14.2761 8.5 14.5 8.27614 14.5 8C14.5 7.72386 14.2761 7.5 14 7.5V8.5ZM9.5 12.5C9.77614 12.5 10 12.2761 10 12C10 11.7239 9.77614 11.5 9.5 11.5V12.5ZM9.5 17.5C9.77614 17.5 10 17.2761 10 17C10 16.7239 9.77614 16.5 9.5 16.5V17.5ZM5 8.5H14V7.5H5V8.5ZM5.40909 12.5H9.5V11.5H5.40909V12.5ZM5.40909 17.5H9.5V16.5H5.40909V17.5Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgTableReport);
export default ForwardRef;
